import { SharedValue, useSharedValue } from "react-native-reanimated";
import { createContext, useContext, useEffect } from "react";
import { useNavigation } from "expo-router";

const ScrollValueContext = createContext<{
  scrollValue: SharedValue<number>;
} | null>(null);

function updateScrollValue(scrollValue: SharedValue<number>, value: number) {
  scrollValue.value = value;
}

export const useScrollValue = () => {
  const context = useContext(ScrollValueContext);
  if (!context) {
    throw new Error("useScrollValue must be used within a ScrollValueProvider");
  }

  const navigation = useNavigation();

  useEffect(() => {
    const cleanupScrollValueOnUnmount = navigation.addListener(
      "beforeRemove",
      () => {
        updateScrollValue(context.scrollValue, 0);
      },
    );

    return cleanupScrollValueOnUnmount;
  }, [navigation, context.scrollValue]);

  return context.scrollValue;
};

export const ScrollValueProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const scrollValue = useSharedValue(0);

  return (
    <ScrollValueContext.Provider value={{ scrollValue }}>
      {children}
    </ScrollValueContext.Provider>
  );
};
